import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { SuburbConfig } from 'config/constants/types'
import type { CouncilsListingsEditState, CouncilsListingsEdit } from '../types'
import { getCouncilListingsEdit } from './helpers'

const noCouncilsListingsEditConfig = {
  listings: [],
  isInitalized: false,
  isLoading: true,
  hasError: false,
  suburb: null,
  suburbIsLoading: true,
  suburbIsInitalized: false,
}

interface SetListingsEditPayload {
  listings: CouncilsListingsEdit[]
}

interface SetSuburbEditPayload {
  suburb: SuburbConfig
}

const initialState: CouncilsListingsEditState = { ...noCouncilsListingsEditConfig }

export const councilsListingsEditSlice = createSlice({
  name: 'CouncilsListings',
  initialState,
  reducers: {
    fetchListingsEdit: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setListingsEdit: (state, action: PayloadAction<SetListingsEditPayload>) => {
      state.listings = action.payload.listings
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchListingsEditFailed: (state) => {
      state.listings = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchCouncilListingsEdit = (ownerName: string, ownerId: string) => async (dispatch) => {
  console.log(ownerName)
  try {
    dispatch(fetchListingsEdit())
    const listings = await getCouncilListingsEdit(ownerName, ownerId)
    dispatch(
      setListingsEdit({
        listings,
      }),
    )
  } catch (error) {
    message.error('Error gettings stats')
    dispatch(fetchListingsEditFailed())
  }
}

// Actions
export const { fetchListingsEdit, setListingsEdit, fetchListingsEditFailed } = councilsListingsEditSlice.actions

export default councilsListingsEditSlice.reducer
